import React from "react";
import Navbar1Combine from "./Header/Navbar1Combine";
import "bootstrap/dist/css/bootstrap.min.css";
import { BrowserRouter as Router } from "react-router-dom";
import { Container, Row, Col, Card } from "react-bootstrap";
import Footer from "./Footer/footer";
import Notiflix from "notiflix";
import banner1 from "./images/banner/innerpagebanner/1.png";
import PostApiCall from "./Helper/PostApi";
import Riskfree from "../components/images/risk_free_icon.png";
import Whyholxo from "../components/images/why_holxo_icon.png";
class Booknow extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      Name: "",
      Email: "",
      Mobile: "",
      destination: "",
      Message: "",
      NumRegex: /^[0-9]*$/,
      EmailRegex:
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    };
  }
  componentDidMount() {
    Notiflix.Notify.init({
      width: "300px",
      position: "right-top",
      distance: "10px",
      opacity: 1,
      clickToClose: true,
      showOnlyTheLastOne: true,
      useFontAwesome: true,
      fontSize: "15px",
      zindex: 15000,
    });
  }
  onPostForm = () => {
    Notiflix.Loading.circle();
    PostApiCall.postRequest(
      {
        name: this.state.Name,
        number: this.state.Mobile,
        email: this.state.Email,
        message: this.state.Message,
      },
      "updateuserenquiries"
    ).then((result) =>
      result.json().then((obj) => {
        if (result.status == 200 || result.status == 201) {
          Notiflix.Loading.remove();
          Notiflix.Notify.success(
            "Your form submitted successfully. Our team will get back to you shortly."
          );
          window.location.reload();
        }
      })
    );
  };
  render() {
    return (
      <Container fluid className="p-0 m-0">
        <Router>
          <Navbar1Combine />
          <div className="p-0 m-0 aboutuscommonbannerall">
            <img
              src={banner1}
              className="forwebsite"
              alt=""
              style={{ width: "100%" }}
            ></img>
            <img src={banner1} alt="" className="aboutwidth formobile"></img>
          </div>
          <Container className="destinationcard">
            <div style={{ display: "flex", justifyContent: "center" }}>
              <h1 className="sectionheading">Contact Us</h1>
            </div>
            <Row>
              <Col xs="12" lg="6">
                <Card className="mx-1 card mt-4 formenquiry">
                  <Card.Body className="p-0 my-4">
                    <Row style={{ paddingLeft: "1em", paddingRight: "1em" }}>
                      <p>
                        Please fill out our enquiry form and we’ll have one of
                        our travel experts call back to help you plan your
                        holiday.
                      </p>
                      <Col xs md="12" style={{ marginBottom: "1em" }}>
                        <input
                          type="text"
                          placeholder="Name*"
                          className="form-control"
                          value={this.state.Name}
                          onChange={(text) => {
                            this.setState({
                              Name: text.target.value,
                            });
                          }}
                        />
                      </Col>
                    </Row>
                    <Row style={{ paddingLeft: "1em", paddingRight: "1em" }}>
                      <Col xs md="12" style={{ marginBottom: "1em" }}>
                        <input
                          type="text"
                          placeholder="Email*"
                          className="form-control"
                          value={this.state.Email}
                          onChange={(text) => {
                            this.setState({
                              Email: text.target.value,
                            });
                          }}
                        />
                      </Col>
                    </Row>
                    <Row style={{ paddingLeft: "1em", paddingRight: "1em" }}>
                      <Col xs md="12" style={{ marginBottom: "1em" }}>
                        <input
                          type="text"
                          placeholder="Contact Number*"
                          className="form-control"
                          value={this.state.Mobile}
                          onChange={(mobile) => {
                            if (
                              this.state.NumRegex.test(mobile.target.value) &&
                              mobile.target.value.length <= 10
                            ) {
                              this.setState({
                                Mobile: mobile.target.value,
                              });
                            }
                          }}
                        />
                      </Col>
                    </Row>
                    <Row style={{ paddingLeft: "1em", paddingRight: "1em" }}>
                      <Col xs md="12">
                        <textarea
                          row="5"
                          col="4"
                          placeholder="Message *"
                          className="form-control"
                          value={this.state.Message}
                          onChange={(text) => {
                            this.setState({
                              Message: text.target.value,
                            });
                          }}
                        />
                      </Col>
                    </Row>
                    <Row style={{ paddingLeft: "1em", paddingRight: "1em" }}>
                      <Col
                        xs="12"
                        md="6"
                        className="book-now-button"
                        style={{ margin: "23px auto 0px auto" }}
                      >
                        <button
                          className="btn booknow"
                          style={{ padding: "12px 5px" }}
                          onClick={() => {
                            if (this.state.Name != "") {
                              if (this.state.Email != "") {
                                if (
                                  this.state.EmailRegex.test(this.state.Email)
                                ) {
                                  if (this.state.Mobile != "") {
                                    if (this.state.Mobile.length == 10) {
                                      if (this.state.Message != "") {
                                        this.onPostForm();
                                      } else {
                                        Notiflix.Notify.failure(
                                          "Please write your message."
                                        );
                                      }
                                    } else {
                                      Notiflix.Notify.failure(
                                        "Please enter valid mobile number."
                                      );
                                    }
                                  } else {
                                    Notiflix.Notify.failure(
                                      "Please enter mobile number."
                                    );
                                  }
                                } else {
                                  Notiflix.Notify.failure(
                                    "Please enter valid email."
                                  );
                                }
                              } else {
                                Notiflix.Notify.failure(
                                  "Please enter email address."
                                );
                              }
                            } else {
                              Notiflix.Notify.failure(
                                "Please enter your name."
                              );
                            }
                          }}
                        >
                          {" "}
                          SEND ENQUIRY
                        </button>
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>
              </Col>
              <Col xs="12" lg="6" style={{ margin: "auto" }}>
                <div class="value_cotainer">
                  <div class="item formenquiry">
                    <img src={Riskfree} />
                    <div class="description">
                      <h3 class="avenir_heavyen">NO OBLIGATION</h3>
                      <p class="avenir_regularen">
                        Get an itinerary from our travel experts, travel only if
                        you like what you see.
                      </p>
                    </div>
                  </div>
                  <div class="item formenquiry">
                    <img src={Whyholxo} />
                    <div class="description">
                      <h3 class="avenir_heavyen">100% SECURE</h3>
                      <p class="avenir_regularen">
                        All your information is kept confidential at all times,
                        used as per our privacy policy.
                      </p>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
          <Footer style={{ margin: "0rem auto auto auto" }} />
        </Router>
      </Container>
    );
  }
}
export default Booknow;
